import React, { useState, useEffect, useContext } from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Button, Container, FormHelperText, IconButton, TextField, Grid, CircularProgress,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { createNewPass } from '../../../../Redux/Models/auth';
import AlertContext from '../../../../Context/AlertContext';

const DisplayingErrorMessagesSchema = Yup.object().shape({
  password: Yup.string()
    .required('Password field is required')
    .min(8, 'Must contain minimum 8 characters')
    .matches(
      /^(?=.*[a-z])/,
      'Must Contain One Lowercase Character',
    )
    .matches(
      /^(?=.*[A-Z])/,
      'Must Contain One Uppercase Character',
    )
    .matches(
      /^(?=.*[0-9])/,
      'Must Contain One Number Character',
    )
    .matches(
      /^(?=.*[!@#$%^&*_\-?])/,
      'Must Contain  One Special Case Character',
    ),
  password2: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords doesn\'t match')
    .required('Password field is required'),
});

export default function CreateNewPass({
  isLoading,
  error,
  message,
  newPasswordSuccess,
  classes,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openAlert } = useContext(AlertContext);
  const { token, email } = useParams();

  const formik = useFormik({
    initialValues: {
      password: '',
      password2: '',
    },
    validationSchema: DisplayingErrorMessagesSchema,
    onSubmit: (values) => {
      dispatch(createNewPass({ token, password: values.password }, email));
    },
  });

  useEffect(() => {
    if (!email || !token) {
      navigate(ROUTES.signin());
    }
  }, [token]);

  const [visible, setVisible] = useState(false);
  const toggleVisibility = () => {
    setVisible(!visible);
  };

  const [visible2, setVisible2] = useState(false);
  const toggleVisibility2 = () => {
    setVisible2(!visible2);
  };

  useEffect(() => {
    if (formik.touched.password2 && newPasswordSuccess) {
      navigate(ROUTES.resetPassSuccess());
    }
  }, [formik.touched.password2, newPasswordSuccess]);

  useEffect(() => {
    if (error) {
      openAlert({
        message,
        severity: 'error',
      });
    }
  }, [error, message]);

  return (
    <div className={classes.root}>
      {/* <Grid container spacing={0}> */}
      {/* <Grid item xs={12} lg={6} sx={{ display: { lg: 'block', xs: 'none' } }}>
          <img
            src={Images.SideWave}
            alt="wave"
            className="side-auth"
          />
        </Grid> */}
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            {/* <IconButton onClick={() => navigate(-1)}>
              <ArrowBackRounded />
            </IconButton> */}
            <div className="center">
              <h1>
                <img src={Images.Logo} alt="Boxpack" height={65} />
              </h1>
              <h3 className="mt-6 s-16">Create new password</h3>

              <div className="height-14 mt-1 desc center s-14">
                Your password must be different
                <br />
                than previously used password
              </div>
            </div>
            <form onSubmit={formik.handleSubmit} className="mt-6">

              <div className="mt-4">
                <label htmlFor="password">
                  New password
                  <span className="primary-green">*</span>
                </label>
                <TextField
                  size="small"
                  type={visible ? 'text' : 'password'}
                  id="password"
                  error={formik.errors.password && formik.touched.password}
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  placeholder="Your new password"
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    endAdornment: (
                      <IconButton sx={{ m: 0, p: 0 }} onClick={toggleVisibility}>
                        {visible
                          ? <Visibility />
                          : <VisibilityOff />}
                      </IconButton>
                    ),
                    autoComplete: 'new-password',
                  }}
                />
                {formik.errors.password && formik.touched.password
                && (
                <FormHelperText error sx={{ fontSize: 14 }}>
                  {formik.errors.password}
                </FormHelperText>
                )}
              </div>

              <div className="mt-4">
                <label htmlFor="password2">
                  Confirm new password
                  <span className="primary-green">*</span>
                </label>
                <TextField
                  size="small"
                  type={visible2 ? 'text' : 'password'}
                  id="password2"
                  error={formik.errors.password2 && formik.touched.password2}
                  name="password2"
                  value={formik.values.password2}
                  onChange={formik.handleChange}
                  placeholder="Your new password"
                  fullWidth
                  autoComplete="off"
                  InputProps={{
                    endAdornment: (
                      <IconButton sx={{ m: 0, p: 0 }} onClick={toggleVisibility2}>
                        {visible2
                          ? <Visibility />
                          : <VisibilityOff />}
                      </IconButton>
                    ),
                    autoComplete: 'new-password',
                  }}
                />
                {formik.errors.password2 && formik.touched.password2
                && (
                <FormHelperText error sx={{ fontSize: 14 }}>
                  {formik.errors.password2}
                </FormHelperText>
                )}
              </div>

              <div className="mt-6">
                <Button disabled={isLoading} startIcon={isLoading && (<CircularProgress size={18} sx={{ mr: 1, color: '#fff' }} />)} size="large" type="submit" variant="contained" className="btn-contained" fullWidth>Confirm password</Button>
              </div>

            </form>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
